'use strict';
angular.module('theme').component('foodCourtLangModal', {
	restrict: 'E',
	template: '',
	controller: function($cookies, $uibModal, LANG) {
		if (LANG === 'nb') {
			var viewed = $cookies.get('foodcourt-lang') || false;

			if (!viewed) {
				var instance = $uibModal.open({
					animation: true,
					templateUrl: 'component/foodcourt-lang-modal.html',
					bindToController: true,
					controllerAs: '$ctrl',
					controller: function ($uibModalInstance) {

						this.close = function () {
							$uibModalInstance.dismiss();
						};
					},
					size: 'mini'
				});

				instance.result.then(null, function () {
					$cookies.put('foodcourt-lang', true, {
						path: '/',
						expires: moment().add(1, 'year').toDate()
					});
				});
			}
		}
	}
});
